import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import {
  urlGetPainelAssumirRotas,
  urlGetPainelAssumirVeiculos,
  urlGetPainelDelegacaoRotas,
  urlGetPainelDelegacaoTps,
  urlGetPainelDelegacaoVeiculos,
  urlGetPainelMonitoramentoEntregas,
  urlGetPainelMonitoramentoEntregasOcorrenciasEntrega,
  urlGetPainelMonitoramentoEntregasRotaInfo,
  urlPostPainelAssumirRotas,
  urlPostPainelAssumirVeiculos,
  urlPostPainelDelegacaoRotas,
  urlPostPainelDelegacaoVeiculos,
  urlPutPainelDelegarRotaAnalista,
  urlSavePainelMonitoramentoEntregasOcorrenciaEntrega,
} from '../../routes/dashboard.routes'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

const PainelMonitoramentoEntregasHttp = {
  async getDashboard(tpId, userId, pInicial, pFinal, analistaEntregaId) {
    try {
      const url = urlGetPainelMonitoramentoEntregas(
        tpId,
        userId,
        pInicial,
        pFinal,
        analistaEntregaId,
      )
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getOcorrenciasEntrega(deliveryStepVehicleId) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().get(
        urlGetPainelMonitoramentoEntregasOcorrenciasEntrega(deliveryStepVehicleId, userId),
      )
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getRotaInfo(fleetId) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().get(
        urlGetPainelMonitoramentoEntregasRotaInfo(fleetId, userId),
      )
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getDelegacaoRotas(analistaOrigemId, rotas, pInicial, pFinal) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().get(
        urlGetPainelDelegacaoRotas(userId, analistaOrigemId, rotas, pInicial, pFinal),
      )
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async salvarDelegacaoRotas(analistaOrigemId, delegacoes) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().post(urlPostPainelDelegacaoRotas(), {
        user_id: userId,
        analista_origem_id: analistaOrigemId,
        delegacoes,
      })
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getDelegacaoTps(analistaOrigemId) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().get(urlGetPainelDelegacaoTps(userId, analistaOrigemId))
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getDelegacaoVeiculos(analistaOrigemId, tpId) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().get(
        urlGetPainelDelegacaoVeiculos(userId, analistaOrigemId, tpId),
      )
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async salvarDelegacaoVeiculos(analistaOrigemId, delegacoes) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().post(urlPostPainelDelegacaoVeiculos(), {
        user_id: userId,
        analista_origem_id: analistaOrigemId,
        delegacoes,
      })
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getAssumirRotas(analistaOrigemId, rotas, pInicial, pFinal) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().get(
        urlGetPainelAssumirRotas(userId, analistaOrigemId, rotas, pInicial, pFinal),
      )
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async salvarAssumirRotas(analistaOrigemId, fleetIds) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().post(urlPostPainelAssumirRotas(), {
        user_id: userId,
        analista_origem_id: analistaOrigemId,
        fleet_ids: fleetIds,
      })
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getAssumirVeiculos(analistaOrigemId) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().get(urlGetPainelAssumirVeiculos(userId, analistaOrigemId))
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async salvarAssumirVeiculos(analistaOrigemId, vehicleIds) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().post(urlPostPainelAssumirVeiculos(), {
        user_id: userId,
        analista_origem_id: analistaOrigemId,
        vehicle_ids: vehicleIds,
      })
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async delegarRotaAnalista(fleetId, analistaDestinoId) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().put(urlPutPainelDelegarRotaAnalista(fleetId), {
        user_id: userId,
        analista_destino_id: analistaDestinoId,
      })
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async saveOcorrenciaEntrega(deliveryStepVehicleId, payload) {
    try {
      const { id: userId } = getUsuarioInfo()
      const response = await authHttp().post(
        urlSavePainelMonitoramentoEntregasOcorrenciaEntrega(deliveryStepVehicleId, userId),
        payload,
      )
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default PainelMonitoramentoEntregasHttp
